const API_URL = process.env.VUE_APP_API_URL;
console.log('API_URL from url.js:', API_URL); // 환경 변수 확인 로그
export default API_URL;


// WEBPACK FOOTER //
// ./src/common/url.js